import { CarmaHttp } from './carma.js'
import { config } from '@/_helpers'


export const $_sign = {
  methods: {
    $sign_carmaInit(f) { carmaInit(f) },
    $sign_setComponent(name) { setComponent(name) },
    $sign_setOk(f) { setOk(f) },
    $sign_setFail(f) { setFail(f) },
    $sign_signSmimeFunction(id, cert) { 
        setDocId(id)
        setCert(cert)
        signSmimeFunction() 
    },
    $sign_signFileFunction(id, cert) { 
        setDocId(id)
        setCert(cert)
        signFileFunction() 
    },
    $sign_loadFunction() { return loadFunction() },
    $sign_showFunction() { showFunction() },
    $sign_certInfo(cert) { return certInfo(cert) },
    $sign_signandcryptFileFunction(id, cert, orgId) {
        setDocId(id)
        setCert(cert)
        setOrgId(orgId)
        signandcryptFileFunction() 
    },
    $sign_signandcryptSmimeFunction(id, cert, orgId) {
        setDocId(id)
        setCert(cert)
        setOrgId(orgId)
        signandcryptSmimeFunction() 
    },

    $sign_viewResponse(part, cert) {
        setDocId(part.partId)
        setDocName(part.partName)
        setCert(cert)
        decodeFileFunction();
    }, 
    $sign_verifyEncResponse(id, sigId, cert) {
        setDocId(id)
        setCert(cert)
        verifyFileFunction(true, sigId);
    }, 
  }
}


export function $sign_verifyResponse(id, sigId, ok, fail) {
    setDocId(id)
    setOk(ok)
    setFail(fail)
    verifyFileFunction(false, sigId);
}



var component='';

var selectedCert;
var fileContent, certContent;
var signatureContent;
var fileId, orgId;
function fileSizePath() { return config.apiUrl+component+'file/size/'; }
function fileGetPath() { return config.apiUrl+component+'file/get/'; }
function fileSignPath() { return config.apiUrl+component+'file/sign/'; }
var fileEncPath = config.apiUrl+'file/enc/';
var fileCertPath = config.apiUrl+'file/cert/';
var uploadMultipartPath = config.apiUrl+'file/decodedmpart/';

var mimeMakePath = config.apiUrl+'file/mimemake/';
var mimeWithSignPath = config.apiUrl+'file/mimewithsign/';

var partSizePath = config.apiUrl+'file/sizeresponsepart/'; 
var partGetPath = config.apiUrl+'file/response/part/';

var loadCertId;

var docName='';

var stores = [
	{
		Location: 'sscu',
		Address: '',
		Name: 'MY'
	}
];

var connstring = "SERVER=\""+config.carmaHost+"\";LOGFILE=\"c:\\EOSCrypto.log\";LOGMODE=\"FULL\"";
var carmaHttp;

var okFunc, failFunc;

const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, {type: contentType});
  return blob;
}

function localSave(data) {
  if(docName.indexOf(".p7m") > -1 ) {
    decryptResultFunction(data);
  } else { 
    const blob = b64toBlob(data, 'application/msword');
    const e = document.createEvent('MouseEvents'),
    a = document.createElement('a');
    a.download = docName;
    a.href = window.URL.createObjectURL(blob);
    a.dataset.downloadurl = ['application/msword', a.download, a.href].join(':');
    e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
    a.dispatchEvent(e);
  }
}

function carmaInit(f) { 
   carmaHttp = new CarmaHttp(connstring, stores, f);
}

function setOk(f) { okFunc=f; }
function setFail(f) { failFunc=f; }


function setComponent(name) {
   component=name+"/";
}

function setDocName(name) {
   docName=name;
}
function setDocId(id) {
   fileId=id;
}
function setOrgId(id) {
   orgId=id;
}
function setCert(cert) {
   selectedCert=cert;
}

function infoFunction(infoText, step) {
	okFunc(infoText,step);
}
function alertFunction(alertText) {
	failFunc(alertText);
}

function getSelectedCert() {
	return selectedCert;
}


function sizeFunction(filepath, fileuid) {
	var xmlHttp = new XMLHttpRequest();
    xmlHttp.open( "GET", filepath+fileuid, false ); // false for synchronous request
    xmlHttp.send( null );
    return xmlHttp.responseText;
}

function sizePartFunction(id) {
	return sizeFunction(partSizePath, id);
}

function sizeFileFunction() {
	return sizeFunction(fileSizePath(), fileId);
}

function decodeFileFunction() {
	loadEncFunction(decodeFunction);
}

function signandcryptFileFunction() {
	loadFileFunction(signAndCryptFunction);
}
function signandcryptSmimeFunction() {
	loadMimeFunction(signAndCryptMiMeFunction, mimeMakePath, fileGetPath());
}

function signFileFunction() {
	loadFileFunction(signFunction);
}

function signSmimeFunction() {
	loadMimeFunction(signFunction, mimeMakePath, fileGetPath());
}

function verifyFileFunction(enc, sigId) {
    if (enc) loadSignFunction(loadEncFunctionToVerify, sigId);
    else loadSignFunction(loadResponseFunction, sigId);
}

function loadEncFunctionToVerify() {
    loadEncFunction(decodeFunctionToVerify);
}

function decodeFunctionToVerify(encodeData) {
	var decodeData="";
    try { decodeData = carmaHttp.Decrypt(encodeData, getSelectedCert()); }
    catch (e) { alertFunction('Ошибка расшифровки документа'); }

	if (decodeData!=null && decodeData!="" ){
        fileContent = decodeData;
        verifyFunction();
	}
	else alertFunction("Ошибка расшифровки документа");
}

function decodeFunction(encodeData) {
	var decodeData="";
    try { decodeData = carmaHttp.Decrypt(encodeData, getSelectedCert()); }
    catch (e) { alertFunction('Ошибка расшифровки документа'); }

	if (decodeData!=null && decodeData!="" ) 		
        localSave(decodeData);
	else 
        alertFunction("Ошибка расшифровки документа");
}

function loadEncFunction(callFunction) {
	var fileSize = sizePartFunction(fileId);
	var chunkSize = 3 * 1024 * 10; // 3MB
    var chunks = Math.ceil(fileSize / chunkSize);
    var currentChunk = 0;
	var encodeContent = "";
	
	var frOnload = function(e) {
        var header = ";base64,";
        var fileData = e.target.result;
		encodeContent+=fileData.substr(fileData.indexOf(header) + header.length);

        currentChunk++;

        if (currentChunk < chunks) {
           loadNext();
        } else {
           var decodeData=window.atob(encodeContent);
           try {
               decodeData = decodeData.replace(/\n/g,'').replace(/\r/g,'');
               decodeData = decodeData.replace("----- BEGIN PKCS7 ENCRYPTED -----","");
               decodeData = decodeData.replace("----- END PKCS7 ENCRYPTED -----","");
               window.atob(decodeData);
               encodeContent=decodeData;
           } catch(e) {
               console.log(e)
           }

           callFunction(encodeContent);
        }
    };
	
	var frOnerror = function() {
		alertFunction('Ошибка загрузки подписи'); 
    };

    function loadNext() {
        var fileReader = new FileReader();
        fileReader.onload = frOnload;
        fileReader.onerror = frOnerror;

        var start = currentChunk * chunkSize,
        end = ((start + chunkSize) >= fileSize) ? fileSize : start + chunkSize;
        
        var xhr = new XMLHttpRequest();
        xhr.open('GET', partGetPath+fileId+"/"+start+"/"+end, true);
        xhr.responseType = 'blob';

        xhr.onload = function() {
            if (this.status == 200) {
                var blob = this.response;
                fileReader.readAsDataURL(blob);
            }
        };
        xhr.send();
    }
	
	loadNext();
}

function loadResponseFunction() {
	var fileSize = sizePartFunction(fileId);
	var chunkSize = 3 * 1024 * 10; // 3MB
    var chunks = Math.ceil(fileSize / chunkSize);
    var currentChunk = 0;
	fileContent = "";
	
	var frOnload = function(e) {
        var header = ";base64,";
        var fileData = e.target.result;
		fileContent+=fileData.substr(fileData.indexOf(header) + header.length);

        currentChunk++;

        if (currentChunk < chunks) {
            loadNext();
        } else {
			verifyFunction();
        }
    };
	
	var frOnerror = function() {
		alertFunction('Ошибка загрузки файла для проверки подписи'); 
    };

    function loadNext() {
        var fileReader = new FileReader();
        fileReader.onload = frOnload;
        fileReader.onerror = frOnerror;

        var start = currentChunk * chunkSize,
        end = ((start + chunkSize) >= fileSize) ? fileSize : start + chunkSize;
        
        var xhr = new XMLHttpRequest();
        xhr.open('GET', partGetPath+fileId+"/"+start+"/"+end, true);
        xhr.responseType = 'blob';

        xhr.onload = function() {
            if (this.status == 200) {
                var blob = this.response;
                fileReader.readAsDataURL(blob);
            }
        };
        xhr.send();
    }
	
	loadNext();
}


function loadSignFunction(callFunction, sigId) {
	var fileSize = sizePartFunction(sigId);

	var chunkSize = 3 * 1024 * 10; // 3MB
    var chunks = Math.ceil(fileSize / chunkSize);
    var currentChunk = 0;
	signatureContent = "";
	
	var frOnload = function(e) {
        var header = ";base64,";
        var fileData = e.target.result;
		signatureContent+=fileData.substr(fileData.indexOf(header) + header.length);

        currentChunk++;

        if (currentChunk < chunks) {
            loadNext();
        } else {
            var decodeData=window.atob(signatureContent);
            try {
                decodeData = decodeData.replace(/\n/g,'').replace(/\r/g,'');
                decodeData = decodeData.replace("----- BEGIN PKCS7 SIGNED -----","");
                decodeData = decodeData.replace("----- END PKCS7 SIGNED -----","");
                window.atob(decodeData);
                signatureContent=decodeData;
            } catch(e) {
                console.log(e)
            }

            callFunction();
        }
    };
	
	var frOnerror = function() {
		alertFunction('Ошибка загрузки подписи'); 
    };

    function loadNext() {
        var fileReader = new FileReader();
        fileReader.onload = frOnload;
        fileReader.onerror = frOnerror;

        var start = currentChunk * chunkSize,
        end = ((start + chunkSize) >= fileSize) ? fileSize : start + chunkSize;
        
        var xhr = new XMLHttpRequest();
        xhr.open('GET', partGetPath+sigId+"/"+start+"/"+end, true);
        xhr.responseType = 'blob';

        xhr.onload = function() {
            if (this.status == 200) {
                var blob = this.response;
                fileReader.readAsDataURL(blob);
            }
        };
        xhr.send();
    }
	
	loadNext();
}

function loadFileFunction(callFunction) {

	var fileSize = sizeFileFunction();
	var chunkSize = 3 * 1024 * 10; // 3MB
    var chunks = Math.ceil(fileSize / chunkSize);
    var currentChunk = 0;
	fileContent = "";
	
	var frOnload = function(e) {
        var header = ";base64,";
        var fileData = e.target.result;
		fileContent+=fileData.substr(fileData.indexOf(header) + header.length);

        currentChunk++;

        if (currentChunk < chunks) {
            loadNext();
        } else {
            callFunction(fileContent);
        }
    };
	
	var frOnerror = function() {
		alertFunction('Ошибка загрузки файла'); 
    };

    function loadNext() {
        var fileReader = new FileReader();
        fileReader.onload = frOnload;
        fileReader.onerror = frOnerror;

        var start = currentChunk * chunkSize,
        end = ((start + chunkSize) >= fileSize) ? fileSize : start + chunkSize;
        
        var xhr = new XMLHttpRequest();
        xhr.open('GET', fileGetPath()+fileId+"/"+start+"/"+end, true);
        xhr.responseType = 'blob';

        xhr.onload = function() {
            if (this.status == 200) {
                var blob = this.response;
                fileReader.readAsDataURL(blob);
            }
        };
        xhr.send();
    }
	
	loadNext();
}

// Unused
// function utf8_to_b64(str) {
// 	return window.btoa(unescape(encodeURIComponent(str)));
// }

// Unused
// function b64_to_utf8(str) {
// 	return decodeURIComponent(escape(window.atob(str)));
// }

function decryptResultFunction(decryptData) {
	var formData = new FormData();
	formData.append("data", decryptData);
	
	var xhr = new XMLHttpRequest();
	xhr.open('POST', uploadMultipartPath+fileId, true);
	xhr.responseType = 'json';

	xhr.onload = function() {
		if (this.status == 200) {
            location.reload(true)
		} else {
            alertFunction('Ошибка проверки подписи'); 
        }
	};
	xhr.send(formData);
}

function cryptResultFunction(cryptData) {
	var formData = new FormData();
	formData.append("enc", cryptData);
	
	//fileEncPath
	var xhr = new XMLHttpRequest();
	xhr.open('POST', fileEncPath+fileId, true);
	xhr.responseType = 'json';

	xhr.onload = function() {
		if (this.status == 200) {
			var blob = this.response;
			infoFunction("Данные зашифрованы успешно "+blob.status, "ENC");
		}
	};
	xhr.send(formData);
}

function signResultFunction(signature) {
	var formData = new FormData();
	formData.append("sign", signature);
	
	//fileSignPath
	var xhr = new XMLHttpRequest();
	xhr.open('POST', fileSignPath()+fileId, true);
	xhr.responseType = 'json';

	xhr.onload = function() {
		if (this.status == 200) {
			var blob = this.response;
			infoFunction("Подпись сформирована успешно "+blob.status, "SIG");
		}
	};
	xhr.send(formData);

}

// Unused
// function verifyResultFunction(info, certInfo) {
// 	infoFunction(info, "VERIFY");
// }

function verifyFunction() {
	var verifyData="";

    try { verifyData = carmaHttp.Verify(fileContent,signatureContent); }
    catch (e) {
		alertFunction('Ошибка проверки подписи'); 
    }

    if (verifyData!=null && verifyData.errorCode==0 && verifyData.verifyResult.SignatureVerifyResult==0) infoFunction(""+verifyData.verifyResult.SignatureVerifyResultString, "VERIFY");
	else alertFunction('Ошибка проверки подписи'); 
}

function certInfo(cert) {
    return carmaHttp.GetCertInfo(cert);
}

function showFunction() {
	//carmaHttp.GetCertInfo(getSelectedCert());
	carmaHttp.ShowCert(getSelectedCert());
}

function loadFunction() {
    var certList=[]
	var certificates = carmaHttp.EnumAllCertificates(stores);
	for (var i = 0; i < certificates.length; i++) {
		try {
			var certInfo = carmaHttp.GetCertInfo(certificates[i]);
			if (certInfo.Validity=="VALID") {
				var oOpt = {};
				oOpt.text = certInfo.Description;
				oOpt.value = certificates[i];
                certList.push(oOpt);
			}
		} catch (e) {
			console.log(e)
		}
	}
    return certList;
}

function signFunction(dataContent) {	
	var signData = carmaHttp.Sign2(dataContent, getSelectedCert(), "", 0, 2, "true/false", '');
	signResultFunction(signData);
}

function signAndCryptFunction(dataContent) {	
    signFunction(dataContent)
    loadOrgCertAndCrypt(dataContent)

}

function loadOrgCertAndCrypt(dataContent) {
	
	certContent = "";
	
	var frOnload = function(e) {
        var header = ";base64,";
        var fileData = e.target.result;
		certContent = fileData.substr(fileData.indexOf(header) + header.length);
		var certData = window.atob(certContent).replace(/\n/g,'').replace(/\r/g,'');
		certData = certData.replace("-----BEGIN CERTIFICATE-----","");
		certData = certData.replace("-----END CERTIFICATE-----","");
		var cert = carmaHttp.SetCert(certData);
		loadCertId = cert.Serial+cert.Issuer;
        cryptFunction(dataContent);
    };
	
	var frOnerror = function() {
		alertFunction('Ошибка загрузки сертификата'); 
    };

	var fileReader = new FileReader();
	fileReader.onload = frOnload;
	fileReader.onerror = frOnerror;
	
	var xhr = new XMLHttpRequest();
	xhr.open('GET', fileCertPath+orgId, true);
	xhr.responseType = 'blob';
	//xhr.responseType = 'arraybuffer';

	xhr.onload = function() {
		if (this.status == 200) {
			var blob = this.response;
			fileReader.readAsDataURL(blob);
		}
	};
	xhr.send();
}

function cryptFunction(dataContent) {	
	var encryptData = carmaHttp.EncryptMulty(dataContent,getSelectedCert(),[loadCertId]);
	cryptResultFunction(encryptData);
}


// SMIME

function loadMimeFunction(callFunction, sizePath, filePath) {

	var fileSize = sizeFunction(sizePath, fileId);
	var chunkSize = 3 * 1024 * 10; // 3MB
    var chunks = Math.ceil(fileSize / chunkSize);
    var currentChunk = 0;
	fileContent = "";
	
	var frOnload = function(e) {
        var header = ";base64,";
        var fileData = e.target.result;
		fileContent+=fileData.substr(fileData.indexOf(header) + header.length);

        currentChunk++;

        if (currentChunk < chunks) {
            loadNext();
        } else {
            callFunction(fileContent);
        }
    };
	
	var frOnerror = function() {
		alertFunction('Ошибка загрузки файла'); 
    };

    function loadNext() {
        var fileReader = new FileReader();
        fileReader.onload = frOnload;
        fileReader.onerror = frOnerror;

        var start = currentChunk * chunkSize,
        end = ((start + chunkSize) >= fileSize) ? fileSize : start + chunkSize;
        
        var xhr = new XMLHttpRequest();
        xhr.open('GET', filePath+fileId+"/"+start+"/"+end, true);
        xhr.responseType = 'blob';

        xhr.onload = function() {
            if (this.status == 200) {
                var blob = this.response;
                fileReader.readAsDataURL(blob);
            }
        };
        xhr.send();
    }
	
	loadNext();
}

function signFunction_A(dataContent) {
    return new Promise(function (resolve, reject) {
        var signData = carmaHttp.Sign2(dataContent, getSelectedCert(), "", 0, 2, "true/false", '');
        var formData = new FormData();
        formData.append("sign", signData);

        var xhr = new XMLHttpRequest();
        xhr.open('POST', fileSignPath()+fileId, true);
        xhr.responseType = 'json';
 
        xhr.onload = function() {
            if (this.status == 200) {
                resolve(true);
            } else {
                reject(false);
            }
        };
        xhr.send(formData);
    });
}

async function signAndCryptMiMeFunction(dataContent) {	
    var signed = await signFunction_A(dataContent);
    if(signed) loadMimeFunction(loadOrgCertAndCrypt, mimeWithSignPath, fileGetPath());
}
